'use strict';

function WealthOverview() {
  this.id = null;
  this.node = null;
  this.extends = [_WealthController, Overview];

  this.contentId = ''; // 'wealth' (defined in pug file)

  this.init = function () {
    this._super();
    this.initPage();
  };

  this.initPage = function () {
    this.initOverview();

    this.elements = {};
    // this.elements.CTA = this.node.querySelector('.js--open-moka-app');
    // this.dialog = this.node.querySelector('#open-moka-dialog');

    // if (this.elements.CTA) {
    //   this.elements.CTA.addEventListener('click', function () {
    //     if (!this.dialog) {
    //       $('<div></div>')
    //         .mogo()
    //         .create('Dialog', {
    //           id: 'open-moka-dialog',
    //           close: true,
    //           url: '/member/wealth/get-moka-dialog', // Pug file containing markup for dialog
    //           onUrlLoaded() {
    //             document.querySelector('#open-moka-dialog').mogo().show();
    //           },
    //           backgroundClose: false
    //         });
    //       this.dialog = document.querySelector('#open-moka-dialog');
    //     } else {
    //       this.dialog.mogo().show();
    //     }
    //   });
    // }
  };

  this.initAllReady = function () {};

  this.destroy = function () {
    this.destroyOverview();
  };
}